<template>
    <div>
        <div class="search-result-list" id="search-result-list">
            <ul v-if="this.$props.computedListView" class="search-result-list-items" id="search-result-list-items">
                <search-result-list-item
                    v-for="(e, i) in rows"
                    :index="i"
                    :elementInfo="e"
                    :key="i">
                </search-result-list-item>
            </ul>
            <table v-else class="search-result-table-items">
                <tr>
                    <th width="1%">
                        <i class="lnr lnr-apartment" style="color: rgb(89, 171, 227);"></i>
                    </th>
                    <th width="1%">&nbsp;</th>
                    <th width="1%">&nbsp;</th>
                    <th width="1%">ОГРН</th>
                    <th>Наименование</th>
                    <th width="1%">Регистрация</th>
                    <th width="1%">Коды</th>
                    <th>Деятельность</th>
                    <th>Руководитель</th>
                    <th>
                        <b>Контакты</b>
                        <br>
                        <span>Показаны первые 3</span>
                    </th>
                </tr>
                <search-result-list-table-item
                    v-for="(e, i) in rows"
                    :index="i"
                    :elementInfo="e"
                    :key="i">
                </search-result-list-table-item>
            </table>
        </div>
    </div>
</template>

<script>
import searchResultListItem from "./searchResultListItem.vue"
import searchResultListTableItem from "./searchResultListTableItem.vue"

export default {
    props: ['computedListView'],
    components: {
        "search-result-list-item": searchResultListItem,
        "search-result-list-table-item": searchResultListTableItem
    },
    computed: {
        rows(){
            return this.$store.state.search.rows
        }
    }
}
</script>

<style scoped>
.search-result-list { padding-top: 20px !important; margin-right: 300px; }
.search-result-list-items { margin: 0 !important; padding: 0 !important; }
.search-result-table-items { width: 100%; max-width: 1100px !important; border-collapse: collapse; }
tr th {
    font-size: 13px;
    padding: 10px;
    padding-left: none;
    border-bottom: solid 1px rgba(150,150,150,0.1);
    text-align: left;
    font-weight: bold;
}
tr th span {
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
}
trhover { background: #fff; }
</style>
